import {fetch, normalize} from "utils/dataAccess";

export function updatePatch(optionValueTranslation, values) {
    return new Promise((resolve, reject) => {
        fetch(optionValueTranslation['@id'], {
            method: "PATCH",
            body: JSON.stringify(values),
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        }).then(response => response.json()).then((retrieved) => {
            resolve(normalize(retrieved));
        }).catch(error => reject(error));
    });
}
